import React from "react";

export default function AdminDashboard() {
    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
            <p>
                Von hier aus können Sie administrative Aufgaben verwalten (z.B. Nutzerverwaltung). Bitte seien Sie vorsichtig mit den Änderungen, die Sie vornehmen.
            </p>
        </div>
    );
}
